module.exports = __webpack_public_path__ + "img/trial1-1.be08862d.png";